import React, { useContext } from "react";

import { useTranslation } from "react-i18next";

import { OfferHistoryPeriodTags } from "@features/offer/shared/event/offer-history/OfferHistoryPeriodTags";
import { EventContext } from "@gp/components";
import { useOfferOptionsContext } from "@state/hooks/offer/useOfferOptionsContext";
import { getOfferHistoryScore } from "@utils/offer/offerHistoryScore";
import { observer } from "mobx-react";

import { LiveMatchTime } from "./LiveMatchTime";
import { StartTime } from "./StartTime";

export function MatchTimeInfo() {
	const event = useContext(EventContext);
	const options = useOfferOptionsContext();

	return (
		<>
			<MatchTimeLiveIcon />
			{!options?.shouldHideTopTag && event.isTopEvent ? (
				<>
					<i className="match__tag match__tag--top u-icon u-icon--sml u-icon--top--str u-color--rate--low" />
					{/* <span className="match__tag match__tag--top tag tag--tny tag--sunny tag--bolder">
						{t("COMMON.TOP_EVENT")}
					</span> */}
				</>
			) : null}

			<OfferHistoryTags />

			<MatchTime />
		</>
	);
}

const OfferHistoryTags = observer(function OfferHistoryTags() {
	const event = useContext(EventContext);
	const options = useOfferOptionsContext();

	if (!options?.isOfferHistory) {
		return null;
	}

	const score = getOfferHistoryScore(event?.result);

	return (
		<OfferHistoryPeriodTags
			eventId={event.id}
			isAfterExtraTime={score.overTime != null}
			isAfterPenalties={score.penalties != null}
			tagBlock="match__tag"
			idPrefix="match-row"
			openOnClick
		/>
	);
});

const MatchTimeLiveIcon = observer(function MatchTimeLiveIcon() {
	const { t } = useTranslation();
	const event = useContext(EventContext);

	if (!event.hasLiveCoverage || event.isLive) {
		return null;
	}

	return (
		<span className="match__tag match__tag--live tag tag--tny tag--live--ghost tag--bolder">
			{t("COMMON.LIVE")}
		</span>
	);
});

const MatchTime = observer(function MatchTime() {
	const event = useContext(EventContext);

	if (event.isLive) {
		return (
			<div className="match__details__time">
				<LiveMatchTime event={event} />
			</div>
		);
	}

	return <StartTime event={event} className="match__details__day" />;
});
